import React, { useEffect, useRef } from "react";
import { gsap } from "gsap";
import lightHouseImage from "../img/envision/valuefirst/cards/valuefirst4.png";

const Valuessecondsection = () => {
  const imgRef = useRef(null); // Reference for the image
  const contentRef = useRef(null); // Reference for the content
  const sectionRef = useRef(null); // Reference for the section

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          // Trigger GSAP animations when the section is in view
          gsap.from(imgRef.current, {
            x: -200, // Start position
            opacity: 0, // Start with transparency
            duration: 1.5, // Animation duration
            ease: "power3.out", // Easing
          });

          gsap.from(contentRef.current, {
            x: 200, // Start position
            opacity: 0, // Start with transparency
            duration: 1.5, // Animation duration
            ease: "power3.out", // Easing
            delay: 0.5, // Add delay for better effect
          });

          // Disconnect observer after the animation is triggered
          observer.disconnect();
        }
      },
      { threshold: 0.2 } // Trigger when 20% of the section is visible
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <section
      ref={sectionRef} // Observe this section
      className="our-value-section our-value-section-imgafter"
      style={{ position: "relative" }}
    >
      <div className="container py-5">
        <div className="row">
          {/* Left Column */}
          <div className="col-12 col-md-5">
            <div className="img-container" ref={imgRef}>
              <img
                className="ls-is-cached lazyloaded"
                alt="OurValue-image"
                loading="lazy"
                style={{ maxWidth: "100%", height: "auto" }}
                height="23"
                width="445"
                src={lightHouseImage}
              
              />
            </div>
          </div>
          {/* Right Column */}
          <div className="col-12 col-md-7">
            <div className="details" ref={contentRef}>
              <h2 style={{textAlign:"center"}}>“Our value is the sum total of our values”</h2>
              <p className="founder-name" style={{fontSize:'20px',fontWeight:'bold'}}>
             CCS Reddy<br />
                <span>Founder and Chairman, Envision</span>
              </p>
              <div className="description" style={{textAlign:'justify'}}>
                <p>
                  At Envision, we live our values daily. Every activity - big or
                  small - is tied together through a fabric of ValuesFIRST
                  resulting in an empowered workforce and an AGILE culture. And
                  while, the meaning and application of the different tenets of
                  values may fluctuate from associate to associate, the
                  overarching principle remains unhinged.
                </p>
                <p style={{textAlign:'justify'}}>
                  That said, our value system is a two-way street. One for the
                  associates and the other for the company itself to uphold the
                  terms of ValuesFIRST in every action.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Absolute Positioned Image */}
      <div>
        <img
          src="#"
          alt="right-side-fix-image"
          style={{
            position: "absolute",
            top: "45%",
            right: "0",
            content: "''",
            backgroundRepeat: "no-repeat",
            transform: "translate(0,-50%)",
            zIndex: 1,
          }}
          loading="lazy"
          height="238"
          width="140"
        />
      </div>
    </section>
  );
};

export default Valuessecondsection;
